var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row py-5"
  }, [_vm._m(0), _c('div', {
    staticClass: "col-12"
  }, [_c('CardMisCompras', {
    attrs: {
      "compras": _vm.compras
    }
  })], 1)])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "col-12"
  }, [_c('h1', {
    staticClass: "funko-favoritos-title"
  }, [_vm._v("Mis Compras")])]);
}]

export { render, staticRenderFns }